import { useFetchListData } from '@/composables'
import { defineStore } from 'pinia'
import { computed } from 'vue'

interface ExtServerOption {
  value: string
  label: string
}

const useExternalServerStore = defineStore('externalServer', () => {
  const { data, loading, fetchData } = useFetchListData<ExtServerOption[]>({
    url: '/api/exchange/get_ext_server_list',
    method: 'POST',
    autoFetch: false,
    showErrorMessage: false,
  })

  const extServerOptions = computed(() => data.value ?? [])

  const reset = () => {
    loading.value = false
    data.value = null
    _initPromise = null
  }

  // Idempotent initializer
  let _initPromise: Promise<void> | null = null
  const init = async (params?: Record<string, any>) => {
    if (_initPromise) return _initPromise
    _initPromise = (async () => {
      if (Array.isArray(data.value) && data.value.length > 0) return
      await fetchData(params)
    })()
    return _initPromise
  }

  return {
    loading,
    data,
    extServerOptions,
    fetchData,
    init,
    reset,
  }
})

export default useExternalServerStore
